import Vue from 'vue';
import moment from 'moment'
import DatePicker from 'vue2-datepicker';

export default {
  data() {
    return {
        loading: false,
        dateFillter: new Date(),
        time3: [ new Date(), new Date() ],
        language: localStorage.getItem('lang'),
        // shortcuts: [
        //     {
        //         text: 'Today',
        //         onClick: () => {
        //             this.time3 = [ new Date(), new Date() ]
        //         }
        //     }
        // ],
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    DatePicker,
    VLoading : require('components/loading/loading.vue')
  },
  mounted() {
    let vm = this;
    vm.loading = false;
    $(document).ready(function(){

        var ctx = document.getElementById("LineChert1").getContext("2d");

        var gradientColorOrange = ctx.createLinearGradient(0, 0, 0, 600);
        gradientColorOrange.addColorStop(0, "#fe763a3b");
        gradientColorOrange.addColorStop(0.5, "#ffffff00");
        gradientColorOrange.addColorStop(1, "#ffffff00");

        var gradientColorBlue = ctx.createLinearGradient(0, 0, 0, 600);
        gradientColorBlue.addColorStop(0, "#2dd8ff3b");
        gradientColorBlue.addColorStop(0.5, "#ffffff00");
        gradientColorBlue.addColorStop(1, "#ffffff00");

        var gradientColorGreen = ctx.createLinearGradient(0, 0, 0, 600);
        gradientColorGreen.addColorStop(0, "#1ca81b3b");
        gradientColorGreen.addColorStop(0.5, "#ffffff00");
        gradientColorGreen.addColorStop(1, "#ffffff00");

        var gradientColor3 = ctx.createLinearGradient(0, 0, 0, 600);
        gradientColor3.addColorStop(0, "#a869a73b");
        gradientColor3.addColorStop(0.5, "#ffffff00");
        gradientColor3.addColorStop(1, "#ffffff00");

        var xPadding = 19;
        var doughnutData = {
            "labels": ["14 FEb", "15 FEb", "16 FEb", "17 FEb", "18 FEb", "19 FEb", "20 FEb", "21 FEb", "22 FEb", "23 FEb", "24 FEb", "25 FEb", "26 FEb", "27 FEb"],
            "datasets": [{
                "label": "TEst",
                "data": [50, 75, 80, 20, 34, 70, 88, 32, 37, 40, 140, 110, 50, 25],
                "backgroundColor": gradientColorOrange,
                "borderColor": "#fe763a",
                "pointBorderColor": "#ffffff",
                "pointBorderWidth": 2,
                "pointBackgroundColor": "#fe763a"
            }
            ,{
                "label": "TEst",
                "data": [100, 50, 75, 30, 86, 44, 20, 50, 77, 40, 15, 110, 130, 65],
                "backgroundColor": gradientColorBlue,
                "borderColor": "#2dd8ff",
                "pointBorderColor": "#ffffff",
                "pointBorderWidth": 2,
                "pointBackgroundColor": "#2dd8ff"
            },{
                "label": "TEst",
                "data": [34, 30, 44, 34, 34, 44, 43, 48, 37, 40, 35, 35, 40, 34],
                "backgroundColor": gradientColorGreen,
                "borderColor": "#1ca81b",
                "pointBorderColor": "#ffffff",
                "pointBorderWidth": 2,
                "pointBackgroundColor": "#1ca81b"
            },{
                "label": "TEst",
                "data": [94, 35, 84, 44, 54, 44, 43, 48, 37, 40, 35, 35, 40, 34],
                "backgroundColor": gradientColor3,
                "borderColor": "#a869a7",
                "pointBorderColor": "#ffffff",
                "pointBorderWidth": 2,
                "pointBackgroundColor": "#a869a7"
            }
            ]
        };
        // var customTooltips = function(tooltip) {
        //     // Tooltip Element
        //     var tooltipEl = document.getElementById('chartjs-tooltip');
        //
        //     if (!tooltipEl) {
        //         tooltipEl = document.createElement('div');
        //         tooltipEl.id = 'chartjs-tooltip';
        //         tooltipEl.innerHTML = "<table></table>"
        //         document.body.appendChild(tooltipEl);
        //     }
        //
        //     // Hide if no tooltip
        //     if (tooltip.opacity === 0) {
        //         tooltipEl.style.opacity = 0;
        //         return;
        //     }
        //
        //     // Set caret Position
        //     tooltipEl.classList.remove('above', 'below', 'no-transform');
        //     if (tooltip.yAlign) {
        //         tooltipEl.classList.add(tooltip.yAlign);
        //     } else {
        //         tooltipEl.classList.add('no-transform');
        //     }
        //
        //     function getBody(bodyItem) {
        //         return bodyItem.lines;
        //     }
        //
        //     // Set Text
        //     if (tooltip.body) {
        //         var titleLines = tooltip.title || [];
        //         var bodyLines = tooltip.body.map(getBody);
        //
        //         var innerHtml = '<thead>';
        //
        //         titleLines.forEach(function(title) {
        //             innerHtml += '<tr><th>' + title + '</th></tr>';
        //         });
        //         innerHtml += '</thead><tbody>';
        //
        //         bodyLines.forEach(function(body, i) {
        //             var colors = tooltip.labelColors[i];
        //             var style = 'background:' + colors.backgroundColor;
        //             style += '; border-color:' + colors.borderColor;
        //             style += '; border-width: 2px';
        //             var span = '<span class="chartjs-tooltip-key" style="' + style + '"></span>';
        //             innerHtml += '<tr><td>' + span + body + '</td></tr>';
        //         });
        //         innerHtml += '</tbody>';
        //
        //         var tableRoot = tooltipEl.querySelector('table');
        //         tableRoot.innerHTML = innerHtml;
        //     }
        //
        //     var position = this._chart.canvas.getBoundingClientRect();
        //
        //     // Display, position, and set styles for font
        //     tooltipEl.style.opacity = 1;
        //     tooltipEl.style.left = position.left + tooltip.caretX + 'px';
        //     tooltipEl.style.top = position.top + tooltip.caretY + 'px';
        //     tooltipEl.style.fontFamily = tooltip._fontFamily;
        //     tooltipEl.style.fontSize = tooltip.fontSize;
        //     tooltipEl.style.fontStyle = tooltip._fontStyle;
        //     tooltipEl.style.padding = tooltip.yPadding + 'px ' + tooltip.xPadding + 'px';
        // };

        Chart.defaults.global.pointHitDetectionRadius = 1;

        vm.chart = new Chart(ctx, {
            type: 'line',
            data: doughnutData,
            options: {
                hover: {
                    mode: 'nearest',
                    intersect: true
                },
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero:true,
                            fontColor: '#a2acb4',
                            padding: 10,

                        },
                        scaleLabel: {
                            display: true
                        },
                        stacked: true,
                    }],
                    xAxes: [{
                        ticks: {
                            fontColor: '#a2acb4'
                        },
                        scaleLabel: {
                            display: true
                        }
                    }]
                },
                tooltips: {
                    position: 'nearest',
                    mode: 'point',
                    intersect: false,
                    yPadding: 15,
                    xPadding: 15,
                    caretSize: 8,
                    backgroundColor: '#fff',
                    titleFontColor: "#000000",
                    bodyFontColor: "#000000",
                    borderColor: 'rgba(0,0,0,1)',
                    borderWidth: 4,
                    // custom: customTooltips
                },
                legend: {
                    display: false
                },
            }
        });



    })


  },
  methods: {
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/market/index/index.js